// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qeeU","title":"Info_title__10fiN","selects":"Info_selects__26ion","requiredAsterisk":"Info_requiredAsterisk__3OOdc"};